/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_1_Item_0_DetailInputs */

const en_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`National honor for integrity, character, and leadership in overcoming life's obstacles`)
};

const es_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distinción nacional a la integridad, el carácter y el liderazgo para superar los obstáculos de la vida`)
};

const de_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nationale Auszeichnung für Integrität, Charakter und Führungsstärke bei der Überwindung von Hindernissen im Leben`)
};

const zh_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表彰在克服人生障碍中展现正直、品格与领导力的全国性荣誉`)
};

const ar_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تكريم وطني للنزاهة والشخصية والقيادة في تجاوز عقبات الحياة`)
};

const fr_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distinction nationale récompensant l’intégrité, le caractère et le leadership face aux obstacles de la vie`)
};

const vi_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinh danh quốc gia cho sự chính trực, nhân cách và khả năng lãnh đạo khi vượt qua những trở ngại trong cuộc sống`)
};

const sw_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heshima ya kitaifa kwa uadilifu, tabia na uongozi katika kushinda vikwazo vya maisha`)
};

const th_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกียรติยศระดับประเทศด้านความซื่อสัตย์ อุปนิสัย และความเป็นผู้นำในการเอาชนะอุปสรรคในชีวิต`)
};

const bs_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nacionalno priznanje za integritet, karakter i liderstvo u prevazilaženju životnih prepreka`)
};

const ja_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人生の困難を乗り越える中で示した誠実さ・人格・リーダーシップをたたえる全国的な栄誉`)
};

const ko_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`삶의 역경을 극복하며 보여 준 성실성·인품·리더십에 대한 전국적 영예`)
};

const pt_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Honraria nacional pela integridade, pelo caráter e pela liderança na superação dos obstáculos da vida`)
};

const it_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onorificenza nazionale per l'integrità, il carattere e la leadership nel superare gli ostacoli della vita`)
};

const sv_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nationell utmärkelse för integritet, karaktär och ledarskap i att övervinna livets hinder`)
};

const nl_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nationale onderscheiding voor integriteit, karakter en leiderschap bij het overwinnen van obstakels in het leven`)
};

const da_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`National hædersbevisning for integritet, karakter og lederskab i at overvinde livets forhindringer`)
};

const nb_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasjonal utmerkelse for integritet, karakter og lederskap i å overvinne livets hindringer`)
};

const fi_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kansallinen tunnustus rehellisyydestä, luonteesta ja johtajuudesta elämän esteiden voittamisessa`)
};

const pl_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krajowe wyróżnienie za uczciwość, charakter i przywództwo w pokonywaniu życiowych przeszkód`)
};

const ru_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Национальная награда за честность, силу характера и лидерство в преодолении жизненных препятствий`)
};

const tr_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hayatın engellerini aşmada dürüstlük, karakter ve liderlik için verilen ulusal ödül`)
};

const hi_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जीवन की बाधाओं को पार करने में ईमानदारी, चरित्र और नेतृत्व के लिए राष्ट्रीय सम्मान`)
};

const id_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penghargaan nasional atas integritas, karakter, dan kepemimpinan dalam mengatasi rintangan hidup`)
};

const ms_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penghormatan kebangsaan atas integriti, keperibadian dan kepimpinan dalam mengatasi halangan hidup`)
};

const cs_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celostátní ocenění za integritu, charakter a vůdčí schopnosti při překonávání životních překážek`)
};

const el_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εθνική διάκριση για ακεραιότητα, χαρακτήρα και ηγεσία στην υπέρβαση των εμποδίων της ζωής`)
};

const he_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אות הוקרה לאומי על יושרה, אופי ומנהיגות בהתגברות על מכשולי החיים`)
};

const af_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasionale eerbewys vir integriteit, karakter en leierskap in die oorkoming van lewenshindernisse`)
};

const hu_about_content_honor_1_item_0_detail = /** @type {(inputs: About_Content_Honor_1_Item_0_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemzeti kitüntetés a tisztességért, a jellemért és a vezetői képességért az élet akadályainak leküzdésében`)
};

/**
* | output |
* | --- |
* | "National honor for integrity, character, and leadership in overcoming life's obstacles" |
*
* @param {About_Content_Honor_1_Item_0_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_1_item_0_detail = /** @type {((inputs?: About_Content_Honor_1_Item_0_DetailInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_1_Item_0_DetailInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_1_item_0_detail(inputs)
	if (locale === "de") return de_about_content_honor_1_item_0_detail(inputs)
	if (locale === "zh") return zh_about_content_honor_1_item_0_detail(inputs)
	if (locale === "ar") return ar_about_content_honor_1_item_0_detail(inputs)
	if (locale === "fr") return fr_about_content_honor_1_item_0_detail(inputs)
	if (locale === "vi") return vi_about_content_honor_1_item_0_detail(inputs)
	if (locale === "sw") return sw_about_content_honor_1_item_0_detail(inputs)
	if (locale === "th") return th_about_content_honor_1_item_0_detail(inputs)
	if (locale === "bs") return bs_about_content_honor_1_item_0_detail(inputs)
	if (locale === "ja") return ja_about_content_honor_1_item_0_detail(inputs)
	if (locale === "ko") return ko_about_content_honor_1_item_0_detail(inputs)
	if (locale === "pt") return pt_about_content_honor_1_item_0_detail(inputs)
	if (locale === "it") return it_about_content_honor_1_item_0_detail(inputs)
	if (locale === "sv") return sv_about_content_honor_1_item_0_detail(inputs)
	if (locale === "nl") return nl_about_content_honor_1_item_0_detail(inputs)
	if (locale === "da") return da_about_content_honor_1_item_0_detail(inputs)
	if (locale === "nb") return nb_about_content_honor_1_item_0_detail(inputs)
	if (locale === "fi") return fi_about_content_honor_1_item_0_detail(inputs)
	if (locale === "pl") return pl_about_content_honor_1_item_0_detail(inputs)
	if (locale === "ru") return ru_about_content_honor_1_item_0_detail(inputs)
	if (locale === "tr") return tr_about_content_honor_1_item_0_detail(inputs)
	if (locale === "hi") return hi_about_content_honor_1_item_0_detail(inputs)
	if (locale === "id") return id_about_content_honor_1_item_0_detail(inputs)
	if (locale === "ms") return ms_about_content_honor_1_item_0_detail(inputs)
	if (locale === "cs") return cs_about_content_honor_1_item_0_detail(inputs)
	if (locale === "el") return el_about_content_honor_1_item_0_detail(inputs)
	if (locale === "he") return he_about_content_honor_1_item_0_detail(inputs)
	if (locale === "af") return af_about_content_honor_1_item_0_detail(inputs)
	if (locale === "hu") return hu_about_content_honor_1_item_0_detail(inputs)
	return en_about_content_honor_1_item_0_detail(inputs)
});